import React from 'react';

export default function CTASection({ title, subtitle, actions }) {
  return (
    <section className="ps-section">
      <div className="ps-section-inner ps-highlight">
        <h2 className="ps-section-title">{title}</h2>
        {subtitle && <p style={{ color: 'var(--gray-600)', marginBottom: '16px' }}>{subtitle}</p>}
        <div className="ps-hero-actions">{actions}</div>
      </div>
    </section>
  );
}
